import { requireAuth } from '@/features/auth/guards/require-auth'
import { OperationsPage } from '@/features/references/operations/operations-page'
import { operationsListQuery } from '@/features/references/operations/operations-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/references/operations')({
  beforeLoad: requireAuth,
  loader: ({ context }) => context.queryClient.ensureQueryData(operationsListQuery()),
  component: OperationsPage,
  staticData: { crumb: messages.crumbs.refOperations },
})
